import { render } from "./Privacy-C007.vue?vue&type=template&id=3fa9b32e&scoped=true"
const script = {}

import "./Privacy-C007.vue?vue&type=style&index=0&id=3fa9b32e&scoped=true&lang=css"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa9b32e"]])

export default __exports__